module.exports = __webpack_public_path__ + "static/media/adidas_right.141dda10.glb";